<script setup>
import { ref, watch, onMounted } from 'vue'
import { useCustomChart } from '@/composable/customChart.js'
import { getFontSize, getThisYear } from '@/js/customChart.js'
import { useUserStore } from '@/store/user'
const userStore = useUserStore()

const chartOptions = {
  padding: 10,
  columns: 2,
  rows: 2,
}
const { canvasWrap, initCustomChart } = useCustomChart(drawChart, chartOptions, false)

import { getPipeLineHygieneList } from '@/api/dashboard'

// props
const props = defineProps({
  gridArea: Object,
  employeeId: String,
  width: Number,
  height: Number,
  fiscalYear:String
})

// data
const fetchedData = ref()

// watch
watch([() => props.employeeId, ()=>props.fiscalYear], async (newValue) => {
  try {
    const [employeeId, fiscalYear] = newValue
    const result = await getPipeLineHygieneList({
      fs_year: fiscalYear,
      employee_id: employeeId
    })
    fetchedData.value = result.rtn.at(0)
    initCustomChart()
  } catch (err) {
    console.error(err)
  }
})

// lifecycle
onMounted(async () => {
  try {
    const employeeId = userStore.isAdmin ? '' : userStore.user.employeeId
    const result = await getPipeLineHygieneList({
      fs_year: props.fiscalYear,
      employee_id: props.employeeId || employeeId
    })
    fetchedData.value = result.rtn.at(0)
    initCustomChart()
  } catch (err) {
    console.error(err)
  }
})

function drawChart(canvasInfo, ctx) {
  drawText(canvasInfo, ctx, {
    value: fetchedData.value.salescnt,
    coords: [1, 1],
    style: {
      fillStyle: getFontColor(fetchedData.value.salescnt)
    }
  })
}

function drawText(canvasInfo, ctx, { value, unit = '', coords: [ x, y ], style = {} }) {
  const coords = [
    canvasInfo.cellWidth * x + canvasInfo.padding,
    canvasInfo.cellHeight * y + canvasInfo.padding,
  ]
  const initStyle = {
    textAlign: 'center',
    textBaseline: 'middle',
    fillStyle: 'black',
  }
  const mergedStyle = {
    ...initStyle,
    ...style
  }
  mergedStyle.font = `${getFontSize(canvasInfo, props.gridArea, 30)}px suit-m`
  if (Object.keys(mergedStyle).length) {
    Object.entries(mergedStyle).forEach(([key, value]) => {
      ctx[key] = value
    }) 
  }
  ctx.fillText(`${value}${unit}`, coords[0], coords[1])
}

function getFontColor(value) {
  return parseInt(value) === 0 ? 'royalblue' : 'red'
}
</script>

<template>
  <article :ref="(element) => canvasWrap = element" :style="{ width: `${width}px`, height: `${height}px` }">
    <canvas id="PipelineHygiene"></canvas>
  </article>
</template>

<style scoped>
article {
  display: flex;
  justify-content: center;
  flex: 1 0 auto;
}
#PipelineHygiene {
  width: 100%;
}
</style>